import { AccountInfo } from '@azure/msal-browser'
import { createContext } from "react"

interface Context {
    accountInfo: null | AccountInfo
}

export const AuthenticationContext = createContext<Context>({
    accountInfo: null
})